module.exports = "/_next/static/images/IlloUseCaseEnrichCustomerProfilesHover-f04c741651b679066e99f1e3dcfabf89.png";